import type { IconSvgObject } from './types';

const PiCircleIcon: IconSvgObject = [
  ["path", { d: "M17 8H9.22222C7.99492 8 7 8.89543 7 10M10.3333 8L9.3738 14.9086C9.29052 15.5083 8.67713 15.9299 8.01245 15.8445C7.5622 15.7866 7.18693 15.5047 7.04309 15.1164L7 15M13.6667 16L14.7778 8", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export default PiCircleIcon;
